import { useMemo } from 'react'

import { CONTROL_CENTRE_API_DOMAIN } from '@/config/constants'
import useAuthenticatedQuery from '@/hooks/useAuthenticatedQuery'
import type { AdminAlertItem, PaginatedResponse } from '@/types/controlCenter'

import { mapAdminAlerts } from '../../utils/mappers'
import { QUERY_KEYS } from '../../utils/queryKeys'
import type { Alert } from '@/types/controlCenter'

const useAlertsData = (): {
  alerts: Alert[]
  isLoading: boolean
  isFetching: boolean
  error: Error | null
  url: string
} => {
  const url = `${CONTROL_CENTRE_API_DOMAIN}/admin/alerts?page=0&size=100`

  const { data, isLoading, isFetching, error } = useAuthenticatedQuery<
    PaginatedResponse<AdminAlertItem>
  >(QUERY_KEYS.alerts, url, {
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  })

  const alerts = useMemo(
    () => (data?.data ? mapAdminAlerts(data.data) : []),
    [data],
  )

  return { alerts, isLoading, isFetching, error: error as Error | null, url }
}

export default useAlertsData
